// Bubbles.js
import React from "react";
import "./Bubbles.css"; // Add this in your public folder as CSS

const Bubbles = () => {
  return (
    <div className="bubbles">
      <div className="bubble" />
      <div className="bubble" />
      <div className="bubble" />
      <div className="bubble" />
      <div className="bubble" />
      <div className="bubble" />
    </div>
  );
};

export default Bubbles;
